import styles from './ProductEndOfLife.module.css';
import ProductEndOfLifeContent from './ProductEndOfLifeContent';

export default function PublicProductEndOfLife() {
  return (
    <div className={styles.publicWrapper}>
      <ProductEndOfLifeContent />
    </div>
  );
}
